import { ISeoFilterState } from "@studyportals/fawkes/programmes-search-seo";
import { FilterKey } from "@studyportals/search-filters/server-side";
import store from "@/study-search/store";
import { ParameterType } from "@/study-search/enums";

export class SeoFilterState implements ISeoFilterState {

	public getSelectedValuesFor(key: FilterKey): readonly string[] {
		const { getters } = store;

		return getters.getFilterValues(key.toString() as ParameterType);
	}

	public getSelectedFilters(): readonly FilterKey[] {
		const { getters } = store;

		const filters = getters.getFilters();
		const filtered = filters.filter(f => {
			const filterValues = getters.getFilterValues(f.key.toString() as ParameterType);

			return filterValues.length > 0;
		});

		return filtered.map(filter => filter.key);
	}
}
